var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3496,
    cy: 12.0186,
    r: 11.75,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3792_16370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2087 16.9121V15.8288C15.2087 15.2541 14.9804 14.703 14.5741 14.2967C14.1677 13.8904 13.6166 13.6621 13.042 13.6621H8.70866C8.13402 13.6621 7.58292 13.8904 7.17659 14.2967C6.77027 14.703 6.54199 15.2541 6.54199 15.8288V16.9121",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8747 11.4954C12.0713 11.4954 13.0413 10.5254 13.0413 9.32878C13.0413 8.13216 12.0713 7.16211 10.8747 7.16211C9.67806 7.16211 8.70801 8.13216 8.70801 9.32878C8.70801 10.5254 9.67806 11.4954 10.8747 11.4954Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.458 16.912V15.8287C18.4576 15.3486 18.2979 14.8823 18.0037 14.5028C17.7096 14.1234 17.2978 13.8524 16.833 13.7324",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 7.23242C15.1331 7.35175 15.5461 7.6228 15.8411 8.00284C16.1361 8.38288 16.2962 8.85029 16.2962 9.33138C16.2962 9.81247 16.1361 10.2799 15.8411 10.6599C15.5461 11.04 15.1331 11.311 14.667 11.4303",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3792_16370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "currentColor",
    transform: "translate(6 5.53711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.fc48ee882fe01fba2229c30deed0b251.svg";
export { ForwardRef as ReactComponent };